import React, { useState, useEffect, useContext } from 'react';
import SwipeableViews from 'react-swipeable-views';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { useWindowSize } from '@react-hook/window-size';
import AppContext from '../../Context/AppContext';
import StepHeader from '../Step1/StepHeader';
import EstablishActionSection from './EstablishAction/EstablishActionSection';
import FinishActions from './EstablishAction/FinishActions';
import configData from '../../config.json';

/** Shared example hints for Step 3 — universal & reachable (not fitness-seeded). */
const UNIVERSAL_ACTION_HINTS = [
    'Walk for 20 minutes after lunch',
    'Call the person I need to talk to',
    'Spend 15 minutes reviewing my goal',
];

const SelectGoalsStep2 = (props) => {
    const { checkUserSession } = useContext(AppContext);
    const currUser = checkUserSession() || {};
    const { token, userId } = currUser;

    const [width, height] = useWindowSize();

    const previewStep3 = (() => {
        try {
            const preview = new URLSearchParams(window.location.search).get(
                'preview'
            );
            return (
                preview === 'step3' ||
                preview === 'step3-actions' ||
                preview === 'actions'
            );
        } catch {
            return false;
        }
    })();

    const previewStep3Tracker = (() => {
        try {
            const preview = new URLSearchParams(window.location.search).get(
                'preview'
            );
            return (
                preview === 'step3-tracker' ||
                preview === 'tracker' ||
                preview === 'step3-finish'
            );
        } catch {
            return false;
        }
    })();

    const [data, changeData] = useState({
        CurrentF: 0,
        // Preview: skip intro video and open the actions card / tracker
        CurrentStep3: previewStep3Tracker ? 2 : previewStep3 ? 1 : 0,
        Action: [{ text: '' }, { text: '' }, { text: '' }],
        My7: [],
        changeData: null,
    });

    function updateIndexStep3(i) {
        changeData((prev) => ({
            ...prev,
            CurrentStep3: (Number(prev.CurrentStep3) || 0) + i,
        }));
    }
    function getURL() {
        return configData.SERVER_URL;
    }
    function changePage() {
        updateIndexStep3(1);
    }
    useEffect(() => {
        if (typeof props.handleChangeHeader === 'function') {
            props.handleChangeHeader(1);
        }

        const applyPreview = (AllProps) => {
            if (previewStep3Tracker) {
                AllProps.CurrentStep3 = 2;
            } else if (previewStep3) {
                AllProps.CurrentStep3 = 1;
            }
            return AllProps;
        };

        const seedDemoMy7 = () => [
            {
                id: 1,
                name: 'Family',
                color: '#FBBF53',
                order: 1,
                text: 'Schedule an appointment with a family counselor',
                completedByDate: new Date('2026-09-11'),
            },
            {
                id: 2,
                name: 'Fun',
                color: '#022B7A',
                order: 2,
                text: "Go somewhere you've always wanted to go",
                completedByDate: new Date('2026-09-12'),
            },
            {
                id: 3,
                name: 'Field',
                color: '#EC0F47',
                order: 3,
                text: 'Look inside my current job for ways to make more impact',
                completedByDate: new Date('2026-09-11'),
            },
            {
                id: 4,
                name: 'Friends',
                color: '#700460',
                order: 4,
                text: 'Find a mentor for the F of Oola I want to grow in',
                completedByDate: new Date('2026-09-12'),
            },
            {
                id: 5,
                name: 'Finance',
                color: '#ABD86D',
                order: 5,
                text: 'Fully funded 7-months of living expenses in my emergency fund',
                completedByDate: new Date('2026-09-11'),
            },
            {
                id: 6,
                name: 'Fitness',
                color: '#15C285',
                order: 6,
                text: 'Lose 10 pounds',
                completedByDate: new Date('2026-09-11'),
            },
            {
                id: 7,
                name: 'Faith',
                color: '#F26636',
                order: 7,
                text: 'Set aside time each day for prayer or meditation',
                completedByDate: new Date('2026-09-10'),
            },
        ];

        if (!userId || !token) {
            changeData((prev) =>
                applyPreview({
                    ...prev,
                    My7: seedDemoMy7(),
                    Action: [{ text: '' }, { text: '' }, { text: '' }],
                    ActionPlaceholders: [...UNIVERSAL_ACTION_HINTS],
                    changeData,
                })
            );
            return undefined;
        }

        const url = `${getURL()}goals/GetUserTopSevenGoals/${userId}`;
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((result) => {
                const payload = result?.data || {};
                const topGoals = Array.isArray(payload.topGoals)
                    ? payload.topGoals
                    : Array.isArray(payload)
                      ? payload
                      : [];

                const My7 = topGoals.map((item) => ({
                    ...item,
                    completedByDate: item.completedByDate
                        ? new Date(item.completedByDate)
                        : null,
                }));

                const Action = [{ text: '' }, { text: '' }, { text: '' }];
                const ActionPlaceholders = [...UNIVERSAL_ACTION_HINTS];

                changeData((prev) =>
                    applyPreview({
                        ...prev,
                        My7: My7.length ? My7 : seedDemoMy7(),
                        Action,
                        ActionPlaceholders,
                        changeData,
                    })
                );
            })
            .catch(() => {
                changeData((prev) =>
                    applyPreview({
                        ...prev,
                        My7: seedDemoMy7(),
                        Action: [{ text: '' }, { text: '' }, { text: '' }],
                        ActionPlaceholders: [...UNIVERSAL_ACTION_HINTS],
                        changeData,
                    })
                );
            });
        return undefined;
    }, [1]);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const obj = (
        <SwipeableViews
            slideClassName="step3Section"
            style={{ width: '100%', height: '100%' }}
            AllState={data}
            index={data.CurrentStep3}
            disabled
        >
            <section
                className="step1__container pv2-step2-video"
                style={
                    props.portalV2
                        ? { height: 'auto' }
                        : { height: '80vh' }
                }
            >
                <div className="stepHeader__container">
                    <StepHeader
                        url="https://player.vimeo.com/video/541811073"
                        title="STEP 3: ESTABLISH 3 ACTIONS"
                        description={
                            'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                        }
                        height="100%"
                        changePage={changePage}
                        mobile={props.mobile}
                        portalV2={!!props.portalV2}
                    />
                </div>
            </section>
            <div className="section">
                {data.CurrentStep3 === 1 ? (
                    <EstablishActionSection
                        isFinishAction={0}
                        AllState={{ ...data, changeData }}
                        updateIndexStep3={updateIndexStep3}
                        mobile={props.mobile}
                        portalV2={props.portalV2}
                    />
                ) : null}
            </div>
            <div
                className="section"
                style={{
                    width: '100%',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                }}
            >
                {data.CurrentStep3 === 2 ? (
                    <FinishActions
                        key={
                            previewStep3Tracker
                                ? 'pv2-step3-tracker-preview'
                                : 'pv2-step3-tracker'
                        }
                        isFinishAction={1}
                        AllState={data}
                        updateIndexStep3={updateIndexStep3}
                        handleChangeHeader={props.handleChangeHeader}
                        mobile={props.mobile}
                        portalV2={props.portalV2}
                    />
                ) : null}
            </div>
        </SwipeableViews>
    );
    return obj;
};

export default SelectGoalsStep2;
